module.exports = __webpack_public_path__ + "media/images/about-72c5eff22da6c17818dda30d7f258872.jpg";